<template>
  <b-form-group>
    <b-row>
      <b-col>
        <b-form-radio-group
          id="radioShowOnlyRequired"
          v-model="showOnlyRequired"
          name="radioShowOnlyRequired">
          <b-form-radio :value="true">Required Fields Only</b-form-radio>
          <b-form-radio :value="false">Display All Fields</b-form-radio>
        </b-form-radio-group>
      </b-col>
    </b-row>
    <div v-for="(section, index) in this.sourceSections" :key="index">
      <b-row>
        <b-col class="title">
          <span>{{ section.name }}</span>
          <a @click="toggleSection(index)" v-show="!section.show">
            <i class="fa fa-plus-circle"></i>
          </a>
          <a @click="toggleSection(index)" v-show="section.show">
            <i class="fa fa-minus-circle"></i>
          </a>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="section" v-show="section.show">
            <div v-for="(field, index) in getSectionFields(section.name)" :key="index">
              <div v-if="showSectionRow(field.required)">
                <div class="column target" v-if="field.required">
                  {{ field.friendly_name }}*:
                </div>
                <div class="column target" v-if="!field.required">
                  {{ field.friendly_name }}:
                </div>
                <div class="column">
                  <b-form-select
                      :id="'dropDownSourceIndex' + field.target "
                      :name="'dropDownSourceIndex' + field.target "
                      data-vv-as="Source"
                      v-validate="'required'"
                      v-model="entity.parser_mapping[field.target].source_index"
                      :options="getSourceColumns(field.default_value)"
                      :disabled="isReadonly"
                      @change="handleSourceIndexChange(field.target, entity.parser_mapping[field.target].source_index)"
                  ></b-form-select>
                  <span class="text-danger">{{ errors.first('dropDownSourceIndex' + field.target) }}</span>
                </div>
                <div class="column format" v-if="field.formats === 'firstNameFormats'">
                  <b-form-select
                      :id="'dropdownFormat' + field.target "
                      :name="'dropdownFormat' + field.target "
                      data-vv-as="Format"
                      v-validate="'required'"
                      v-model="entity.parser_mapping[field.target].format"
                      :options="firstNameFormats"
                      :disabled="isReadonly"
                  ></b-form-select>
                  <span class="text-danger">{{ errors.first('dropdownFormat' + field.target) }}</span>
                </div>
                <div class="column format" v-if="field.formats === 'lastNameFormats'">
                  <b-form-select
                      :id="'dropdownFormat' + field.target "
                      :name="'dropdownFormat' + field.target "
                      data-vv-as="Format"
                      v-validate="'required'"
                      v-model="entity.parser_mapping[field.target].format"
                      :options="lastNameFormats"
                      :disabled="isReadonly"
                  ></b-form-select>
                  <span class="text-danger">{{ errors.first('dropdownFormat' + field.target) }}</span>
                </div>
                <div class="column format" v-if="field.formats === 'newOrRefillFormats' &&
                  entity.parser_mapping[field.target].source_index !== -1">
                  <b-form-select
                      :id="'dropdownFormat' + field.target "
                      :name="'dropdownFormat' + field.target "
                      data-vv-as="Format"
                      v-validate="'required'"
                      v-model="entity.parser_mapping[field.target].format"
                      :options="newOrRefillFormats"
                      :disabled="isReadonly"
                  ></b-form-select>
                  <span class="text-danger">{{ errors.first('dropdownFormat' + field.target) }}</span>
                </div>
                <div class="column format" v-if="field.default_value === 'User Defined' &&
                  entity.parser_mapping[field.target].source_index === -1">
                  <b-form-input
                      :id="'inputFormatValue' + field.target "
                      :name="'inputFormatValue' + field.target "
                      data-vv-as="Pharmacy Name"
                      v-model="entity.parser_mapping[field.target].format_value"
                      v-validate="'required'"
                      placeholder="Enter Pharmacy Name"
                      :disabled="isReadonly"
                  ></b-form-input>
                  <span class="text-danger">{{ errors.first('inputFormatValue' + field.target) }}</span>
                </div>
                <div class="column" v-if="field.format_values === 'dateFormatValues' && entity.parser_mapping[field.target].source_index !== -1">
                  <b-form-select
                      :id="'dropdownFormatValue' + field.target "
                      :name="'dropdownFormatValue' + field.target "
                      data-vv-as="Format Value"
                      v-validate="'required'"
                      v-model="entity.parser_mapping[field.target].format"
                      :options="dateFormatValues"
                      :disabled="isReadonly"
                      @change="handleDateFormatChange(field.target)"
                  ></b-form-select>
                  <span class="text-danger">{{ errors.first('dropdownFormatValue' + field.target) }}</span>
                </div>
                <div class="column custom-format"
                  v-if="field.format_values !== null &&
                    entity.parser_mapping[field.target].format !== undefined &&
                    entity.parser_mapping[field.target].format === 'Other'">
                  <b-form-input
                      :id="'inputFormatValue' + field.target "
                      :name="'inputFormatValue' + field.target "
                      data-vv-as="Custom Format"
                      v-model="entity.parser_mapping[field.target].format_value"
                      v-validate="'required'"
                      placeholder="Enter Custom Format"
                      :disabled="isReadonly"
                  ></b-form-input>
                  <span class="text-danger">{{ errors.first('inputFormatValue' + field.target) }}</span>
                </div>
                <div style="clear:both;"></div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </b-form-group>
</template>

<script>
  export default {
    name: "VCopayEPAFileParser",
    props: {
      entity: {
        required: true,
        type: Object
      },
      isReadonly: {
        required: false,
        type: Boolean
      }
    },
    watch: {
      showOnlyRequired: function() {
        this.$validator.reset();
      }
    },
    methods: {
      toggleSection(index) {
        this.sourceSections[index].show = !this.sourceSections[index].show;
      },
      getSectionFields(sectionName) {
        return this.sourceSectionFields.filter(q => q.section === sectionName);
      },
      getSourceColumns(defaultValue) {
        let data = [];
        if (defaultValue !== "") {
          let defaultOption = {
            value: -1,
            text: defaultValue,
            selected: true
          };
          data.push(defaultOption);
        }
        for (let i = 0; i < this.sourceColumns.length; i++) {
          data.push(this.sourceColumns[i]);
        }
        return data;
      },
      handleSourceIndexChange(target, sourceIndex) {
        if (target === "pharmacy_name") {
          if (sourceIndex === -1) {
            this.entity.parser_mapping["pharmacy_name"].format = "UserDefined";
          } else {
            this.entity.parser_mapping["pharmacy_name"].format = null;
          }
        } else {
          if (sourceIndex === -1) {
            this.entity.parser_mapping[target].format = null;
          }
        }
      },
      handleDateFormatChange(target) {
        if (this.entity.parser_mapping[target].format !== "Other") {
          this.entity.parser_mapping[target].format_value = this.entity.parser_mapping[target].format;
        } else {
          this.entity.parser_mapping[target].format_value = null;
        }
      },
      showSectionRow(isFieldRequired) {
        if (isFieldRequired) {
          return true;
        } else {
          return (!this.showOnlyRequired);
        }
      }
    },
    data() {
      return {
        showOnlyRequired: true,
        firstNameFormats: [
          { value: "GetStringValue", text: "First Name is in its own field" },
          { value: "GetFirstNameFromFirstNameLastNameField", text: "First name followed by last name" },
          { value: "GetFirstNameFromLastNameFirstNameField", text: "Last name comma first name" }
        ],
        lastNameFormats: [
          { value: "GetStringValue", text: "Last Name is in its own field" },
          { value: "GetLastNameFromFirstNameLastNameField", text: "First name followed by last name" },
          { value: "GetLastNameFromLastNameFirstNameField", text: "Last name comma first name" }
        ],
        newOrRefillFormats: [
          { value: "NewRefillFromFillCount", text: "From fill count" },
          { value: "NewRefillFromRefillIndicator", text: "New or Refill indicator" }
        ],
        dateFormatValues: [
          "mm/dd/yyyy",
          "mm-dd-yyyy",
          "m/d/yyyy",
          "m-d-yyyy",
          "yyyy-mm-dd",
          "yyyymmdd",
          "Other"
        ],
        sourceColumns: [
          { value: 0, text: "Column A" },
          { value: 1, text: "Column B" },
          { value: 2, text: "Column C" },
          { value: 3, text: "Column D" },
          { value: 4, text: "Column E" },
          { value: 5, text: "Column F" },
          { value: 6, text: "Column G" },
          { value: 7, text: "Column H" },
          { value: 8, text: "Column I" },
          { value: 9, text: "Column J" },
          { value: 10, text: "Column K" },
          { value: 11, text: "Column L" },
          { value: 12, text: "Column M" },
          { value: 13, text: "Column N" },
          { value: 14, text: "Column O" },
          { value: 15, text: "Column P" },
          { value: 16, text: "Column Q" },
          { value: 17, text: "Column R" },
          { value: 18, text: "Column S" },
          { value: 19, text: "Column T" },
          { value: 20, text: "Column U" },
          { value: 21, text: "Column V" },
          { value: 22, text: "Column W" },
          { value: 23, text: "Column X" },
          { value: 24, text: "Column Y" },
          { value: 25, text: "Column Z" },
          { value: 26, text: "Column AA" },
          { value: 27, text: "Column AB" },
          { value: 28, text: "Column AC" },
          { value: 29, text: "Column AD" },
          { value: 30, text: "Column AE" },
          { value: 31, text: "Column AF" },
          { value: 32, text: "Column AG" },
          { value: 33, text: "Column AH" },
          { value: 34, text: "Column AI" },
          { value: 35, text: "Column AJ" },
          { value: 36, text: "Column AK" },
          { value: 37, text: "Column AL" },
          { value: 38, text: "Column AM" },
          { value: 39, text: "Column AN" },
          { value: 40, text: "Column AO" },
          { value: 41, text: "Column AP" },
          { value: 42, text: "Column AQ" },
          { value: 43, text: "Column AR" },
          { value: 44, text: "Column AS" },
          { value: 45, text: "Column AT" },
          { value: 46, text: "Column AU" },
          { value: 47, text: "Column AV" },
          { value: 48, text: "Column AW" },
          { value: 49, text: "Column AX" },
          { value: 50, text: "Column AY" },
          { value: 51, text: "Column AZ" },
          { value: 52, text: "Column BA" },
          { value: 53, text: "Column BB" },
          { value: 54, text: "Column BC" },
          { value: 55, text: "Column BD" },
          { value: 56, text: "Column BE" },
          { value: 57, text: "Column BF" },
          { value: 58, text: "Column BG" },
          { value: 59, text: "Column BH" },
          { value: 60, text: "Column BI" },
          { value: 61, text: "Column BJ" },
          { value: 62, text: "Column BK" },
          { value: 63, text: "Column BL" },
          { value: 64, text: "Column BM" },
          { value: 65, text: "Column BN" },
          { value: 66, text: "Column BO" },
          { value: 67, text: "Column BP" },
          { value: 68, text: "Column BQ" },
          { value: 69, text: "Column BR" },
          { value: 70, text: "Column BS" },
          { value: 71, text: "Column BT" },
          { value: 72, text: "Column BU" },
          { value: 73, text: "Column BV" },
          { value: 74, text: "Column BW" },
          { value: 75, text: "Column BX" },
          { value: 76, text: "Column BY" },
          { value: 77, text: "Column BZ" }
        ],
        sourceSections: [
          { name: "Patient", show: true },
          { name: "Prescriber", show: true },
          { name: "Pharmacy", show: true },
          { name: "Claim", show: true },
          { name: "Prescription", show: true }
        ],
        sourceSectionFields: [
          { section: "Patient", target: "patient_first_name", friendly_name: "First Name", required: true, formats: "firstNameFormats", format_values: null, default_value: "" },
          { section: "Patient", target: "patient_last_name", friendly_name: "Last Name", required: true, formats: "lastNameFormats", format_values: null, default_value: "" },
          { section: "Patient", target: "date_of_birth", friendly_name: "DOB", required: true, formats: null, format_values: "dateFormatValues", default_value: "" },
          { section: "Patient", target: "pt_address_line1", friendly_name: "Address Line 1", required: true, formats: null, format_values: null, default_value: "System Default" },
          { section: "Patient", target: "pt_address_line2", friendly_name: "Address Line 2", required: false, formats: null, format_values: null, default_value: "Not Provided" },
          { section: "Patient", target: "pt_city", friendly_name: "City", required: true, formats: null, format_values: null, default_value: "System Default" },
          { section: "Patient", target: "pt_state", friendly_name: "State", required: true, formats: null, format_values: null, default_value: "System Default" },
          { section: "Patient", target: "pt_zip_code", friendly_name: "Zip Code", required: true, formats: null, format_values: null, default_value: "" },
          { section: "Patient", target: "gender_code", friendly_name: "Gender Code", required: true, formats: null, format_values: null, default_value: "" },
          { section: "Patient", target: "pt_phone_number", friendly_name: "Phone Number", required: false, formats: null, format_values: null, default_value: "Not Provided" },
          { section: "Prescriber", target: "prescriber_npi", friendly_name: "NPI", required: true, formats: null, format_values: null, default_value: "" },
          { section: "Prescriber", target: "prescriber_dea", friendly_name: "DEA", required: false, formats: null, format_values: null, default_value: "Not Provided" },
          { section: "Prescriber", target: "prescriber_fn", friendly_name: "First Name", required: true, formats: "firstNameFormats", format_values: null, default_value: "System Default" },
          { section: "Prescriber", target: "prescriber_ln", friendly_name: "Last Name", required: true, formats: "lastNameFormats", format_values: null, default_value: "System Default" },
          { section: "Prescriber", target: "prescriber_add1", friendly_name: "Address Line 1", required: true, formats: null, format_values: null, default_value: "System Default" },
          { section: "Prescriber", target: "prescriber_add2", friendly_name: "Address Line 2", required: false, formats: null, format_values: null, default_value: "Not Provided" },
          { section: "Prescriber", target: "prescriber_city", friendly_name: "City", required: true, formats: null, format_values: null, default_value: "System Default" },
          { section: "Prescriber", target: "prescriber_state", friendly_name: "State", required: true, formats: null, format_values: null, default_value: "System Default" },
          { section: "Prescriber", target: "prescriber_zip", friendly_name: "Zip Code", required: true, formats: null, format_values: null, default_value: "System Default" },
          { section: "Prescriber", target: "prescriber_phone", friendly_name: "Phone Number", required: true, formats: null, format_values: null, default_value: "System Default" },
          { section: "Prescriber", target: "prescriber_fax", friendly_name: "Fax Number", required: true, formats: null, format_values: null, default_value: "System Default" },
          { section: "Pharmacy", target: "pharmacy_name", friendly_name: "Name", required: true, formats: null, format_values: null, default_value: "User Defined" },
          { section: "Pharmacy", target: "pharmacy_npi", friendly_name: "NPI", required: false, formats: null, format_values: null, default_value: "Not Provided" },
          { section: "Pharmacy", target: "pharmacy_ncpdp_number", friendly_name: "NCPDP ID", required: false, formats: null, format_values: null, default_value: "Not Provided" },
          { section: "Pharmacy", target: "pharmacy_add1", friendly_name: "Address Line 1", required: false, formats: null, format_values: null, default_value: "Not Provided" },
          { section: "Pharmacy", target: "pharmacy_add2", friendly_name: "Address Line 2", required: false, formats: null, format_values: null, default_value: "Not Provided" },
          { section: "Pharmacy", target: "pharmacy_city", friendly_name: "City", required: false, formats: null, format_values: null, default_value: "Not Provided" },
          { section: "Pharmacy", target: "pharmacy_state", friendly_name: "State", required: false, formats: null, format_values: null, default_value: "Not Provided" },
          { section: "Pharmacy", target: "pharmacy_zip", friendly_name: "Zip Code", required: false, formats: null, format_values: null, default_value: "Not Provided" },
          { section: "Pharmacy", target: "pharmacy_phone", friendly_name: "Phone Number", required: true, formats: null, format_values: null, default_value: "System Default" },
          { section: "Pharmacy", target: "pharmacy_fax", friendly_name: "Fax Number", required: false, formats: null, format_values: null, default_value: "Not Provided" },
          { section: "Claim", target: "claim_date", friendly_name: "Claim Date", required: true, formats: null, format_values: "dateFormatValues", default_value: "" },
          { section: "Claim", target: "primary_payer_pbm_name", friendly_name: "Primary Payer PBM Name", required: false, formats: null, format_values: null, default_value: "Not Provided" },
          { section: "Claim", target: "primary_payer_bin", friendly_name: "Primary Payer BIN", required: false, formats: null, format_values: null, default_value: "Not Provided" },
          { section: "Claim", target: "primary_payer_pcn", friendly_name: "Primary Payer PCN", required: false, formats: null, format_values: null, default_value: "Not Provided" },
          { section: "Claim", target: "primary_payer_plan_id", friendly_name: "Primary Payer Plan ID", required: false, formats: null, format_values: null, default_value: "Not Provided" },
          { section: "Claim", target: "primary_payer_plan_name", friendly_name: "Primary Payer Plan Name", required: false, formats: null, format_values: null, default_value: "Not Provided" },
          { section: "Claim", target: "primary_payer_group_id", friendly_name: "Primary Payer Group ID", required: false, formats: null, format_values: null, default_value: "Not Provided" },
          { section: "Claim", target: "primary_payer_group_name", friendly_name: "Primary Payer Group Name", required: false, formats: null, format_values: null, default_value: "Not Provided" },
          { section: "Claim", target: "copay_payer_bin", friendly_name: "Copay Payer BIN", required: false, formats: null, format_values: null, default_value: "Not Provided" },
          { section: "Claim", target: "copay_payer_pcn", friendly_name: "Copay Payer PCN", required: false, formats: null, format_values: null, default_value: "Not Provided" },
          { section: "Claim", target: "copay_payer_group_id", friendly_name: "Copy Payer Group ID", required: false, formats: null, format_values: null, default_value: "Not Provided" },
          { section: "Claim", target: "copay_payer_member_id", friendly_name: "Copy Payer Member ID", required: false, formats: null, format_values: null, default_value: "Not Provided" },
          { section: "Claim", target: "cob_primary_reject_code1", friendly_name: "Primary Payer Reject Code 1", required: false, formats: null, format_values: null, default_value: "Not Provided" },
          { section: "Claim", target: "cob_primary_reject_code2", friendly_name: "Primary Payer Reject Code 2", required: false, formats: null, format_values: null, default_value: "Not Provided" },
          { section: "Claim", target: "cob_primary_reject_code3", friendly_name: "Primary Payer Reject Code 3", required: false, formats: null, format_values: null, default_value: "Not Provided" },
          { section: "Claim", target: "patient_out_of_pocket", friendly_name: "Patient Out of Pocket", required: false, formats: null, format_values: null, default_value: "Not Provided" },
          { section: "Claim", target: "other_coverage_code", friendly_name: "Other Coverage Code", required: false, formats: null, format_values: null, default_value: "Not Provided" },
          { section: "Prescription", target: "rx_number", friendly_name: "RX Number", required: true, formats: null, format_values: null, default_value: "" },
          { section: "Prescription", target: "date_filled", friendly_name: "Date Filled", required: false, formats: null, format_values: "dateFormatValues", default_value: "Not Provided" },
          { section: "Prescription", target: "drug_ndc_number", friendly_name: "NDC", required: true, formats: null, format_values: null, default_value: "" },
          { section: "Prescription", target: "drug_name", friendly_name: "Drug Description", required: true, formats: null, format_values: null, default_value: "" },
          { section: "Prescription", target: "quantity_dispensed", friendly_name: "Quantity", required: true, formats: null, format_values: null, default_value: "" },
          { section: "Prescription", target: "days_supply", friendly_name: "Days Supply", required: false, formats: null, format_values: null, default_value: "Not Provided" },
          { section: "Prescription", target: "number_of_refills_authorized", friendly_name: "Number of Refills Authorized", required: true, formats: null, format_values: null, default_value: "System Default" },
          { section: "Prescription", target: "daw_code", friendly_name: "DAW Code", required: true, formats: null, format_values: null, default_value: "System Default" },
          { section: "Prescription", target: "date_written", friendly_name: "Date Written", required: true, formats: null, format_values: "dateFormatValues", default_value: "" },
          { section: "Prescription", target: "new_or_refill", friendly_name: "New or Refill", required: false, formats: "newOrRefillFormats", format_values: null, default_value: "Not Provided" },
          { section: "Prescription", target: "fill_number", friendly_name: "Refill Number", required: false, formats: null, format_values: null, default_value: "Not Provided" }
        ]
      };
    }
  };
</script>

<style lang="scss">
  .title {
    font-weight: bold;
    padding-top: 8px;
    padding-bottom: 8px;
  }
  .title a {
    margin-left: 12px;
  }
  .section {
    border: solid 1px #dee2e6;
    width: 100%;
    max-height: 268px;
    overflow: auto;
    padding: 4px;
  }
  .column {
    float: left;
    width: 175px;
    padding: 6px 4px;
  }
  .target {
     height: 52px;
     vertical-align: middle;
  }
  .format {
    width: 375px;
  }
  .custom-format {
    width: 200px;
  }
  #radioShowOnlyRequired {
    padding-left: 20px;
  }
  #radioShowOnlyRequired label {
    padding-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/VCopayEPAFileParser.vue